function LoadingState({ title = "Icerikler yukleniyor..." }) {
  return (
    <div className="glass-panel empty-state">
      <div className="loading-pulse" />
      <h3>{title}</h3>
      <p>WordPress ya da local fallback kaynagindan veriler hazirlaniyor.</p>
    </div>
  );
}

export default LoadingState;
